export default __webpack_public_path__ + "static/media/checkout1.a61b4f58.png";